<template>
  <a-modal
    :afterClose="afterClose"
    :bodyStyle="bodyStyle"
    :cancelText="cancelText"
    :centered="centered"
    :closable="closable"
    :closeIcon="closeIcon"
    :confirmLoading="confirmLoading"
    :destroyOnClose="destroyOnClose"
    :footer="footer"
    :forceRender="forceRender"
    :getContainer="getContainer"
    :keyboard="keyboard"
    :mask="mask"
    :maskClosable="maskClosable"
    :maskStyle="maskStyle"
    :okText="okText"
    :okType="okType"
    :okButtonProps="okButtonProps"
    :cancelButtonProps="cancelButtonProps"
    :title="title"
    :visible="visible"
    :width="width"
    :wrapClassName="wrapClassName"
    :zIndex="zIndex"
    :dialogStyle="dialogStyle"
    :dialogClass="dialogClassComputed"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template slot="title">
      <slot name="title"></slot>
    </template>

    <slot></slot>

    <template slot="footer">
      <slot name="footer"></slot>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    //#region 原生参数(https://www.antdv.com/components/modal-cn/#API)
    afterClose: { type: Function },
    bodyStyle: { type: Object, default: {} },
    cancelText: { type: String },
    centered: { type: Boolean, default: true },
    closable: { type: Boolean, default: true },
    closeIcon: { type: Object },
    confirmLoading: { type: Boolean, default: false },
    destroyOnClose: { type: Boolean, default: true },
    footer: { type: Object },
    forceRender: { type: Boolean, default: false },
    getContainer: { type: Object, default: () => document.body },
    keyboard: { type: Boolean, default: false },
    mask: { type: Boolean, default: true },
    maskClosable: { type: Boolean, default: false },
    maskStyle: { type: Object, default: {} },
    okText: { type: String },
    okType: { type: String, default: 'primary' },
    okButtonProps: { type: Object },
    cancelButtonProps: { type: Object },
    title: { type: String | Object },
    visible: { type: Boolean, default: false },
    width: { type: String | Number, default: null },
    wrapClassName: { type: String },
    zIndex: { type: Number, default: 1000 },
    dialogStyle: { type: Object },
    dialogClass: { type: String, default: '' },
    //#endregion 原生参数

    //#region 自定义参数
    // 弹出框大小 可选 smaller small normal big full
    size: { type: String, default: 'smaller' },
    // 项目列数
    column: { type: Object, default: 1 },
    //#endregion 自定义参数
  },
  data() {
    return {
      dialogClassComputed: '',
    }
  },
  watch: {
    size: {
      immediate: true,
      handler() {
        this.handleResize()
      },
    },
    width: {
      immediate: true,
      handler() {
        this.handleResize()
      },
    },
    visible: {
      handler(newVal, oldVal) {
        if (newVal == true && oldVal == false) {
          this.handleResize()

          var that = this
          window.onresize = function () {
            that.handleResize()

            document.querySelectorAll('[class^="sync-to"]').forEach((element) => {
              element.classList.remove('sync-observed')
            })
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  beforeUpdate() {},
  methods: {
    handleOk(e) {
      this.$emit('ok')
    },
    handleCancel(e) {
      this.$emit('cancel')
    },
    handleResize() {
      // 明确指定了宽度的话优先
      if (this.width) {
        if (this.width.toLowerCase && this.width.toLowerCase().indexOf('px') >= 0) {
          this.width = Number(this.width.toLowerCase().replaceAll('px', ''))
        }
        if (this.width.toLowerCase && this.width.toLowerCase().indexOf('%') >= 0) {
          this.width = (window.innerWidth * Number(this.width.toLowerCase().replaceAll('%', ''))) / 100
        }

        var size = 'normal'
        if (this.width <= 600) {
          this.column = 1

          size = 'smaller'
        } else if (600 < this.width && this.width <= 1000) {
          this.column = 1

          size = 'smaller'
        } else if (1000 < this.width && this.width <= 1350) {
          this.column = 2

          size = 'small'
        } else if (1350 < this.width && this.width <= 1800) {
          this.column = 3

          size = 'normal'
        } else {
          this.column = 4

          size = 'big'
        }

        if (this.dialogClass) {
          this.dialogClassComputed = this.dialogClass + ' ant-modal-' + size
        } else {
          this.dialogClassComputed = 'ant-modal-' + size
        }
      }
      // 通过size确定布局
      else {
        switch (this.size) {
          case 'smaller':
            this.column = 1
            break

          case 'small':
            this.column = 2
            break

          case 'normal':
            this.column = 3
            break

          case 'big':
            this.column = 4
            break

          case 'full':
            if (window.innerWidth <= 600) {
              this.column = 1
            } else if (600 < window.innerWidth && window.innerWidth <= 1000) {
              this.column = 1
            } else if (1000 < window.innerWidth && window.innerWidth <= 1350) {
              this.column = 2
            } else if (1350 < window.innerWidth && window.innerWidth <= 1800) {
              this.column = 3
            } else {
              this.column = 4
            }
            break

          default:
            this.size = 'smaller'
            this.column = 1
            break
        }

        if (this.dialogClass) {
          this.dialogClassComputed = this.dialogClass + ' ant-modal-' + this.size
        } else {
          this.dialogClassComputed = 'ant-modal-' + this.size
        }
      }

      this.$parent.column = this.column
    },
  },
}
</script>
